import { OnboardingAccountsInOrganizations } from 'modules/onboarding/common/components';

import { useAccountsInOrganizations } from '../hooks/useAccountsInOrganizations';
import { PageComponentProps } from '../types';

export const AccountsInOrganizationsStep = ({
  canGoBack,
}: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
  } = useAccountsInOrganizations();

  return (
    <OnboardingAccountsInOrganizations
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
